<template>
  <el-dialog :visible="show" :title="`复拍-【${row.name}】`" width="600px" append-to-body @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm" size="medium">
      <el-form-item label="拍摄日期" prop="record_time" :rules="{ required: true, message: '拍摄日期必填' }">
        <el-date-picker v-model="vForm.record_time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%" />
      </el-form-item>
      <el-form-item label="现有分组">
        <div class="group-list" v-loading="groupListLoading">
          <div v-for="(item, index) in groupList" :key="item.id" class="group-item" :class="{ active: index == 0 }">{{ item.record_time }}</div>
        </div>
        <div class="v-form-tips">复拍已当前最后一组分组为模板创建</div>
      </el-form-item>
      <el-form-item label="全景图片" required>
        <vr-upload
          :loading.sync="doSubmitLoading"
          @success="
            (images) => {
              vForm.keys = vForm.keys.concat(images);
            }
          "
        />
        <div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px</div>
      </el-form-item>
      <el-form-item label="是否显示" required>
        <el-radio v-model="vForm.status" :label="1">显示</el-radio>
        <el-radio v-model="vForm.status" :label="2">隐藏</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
    <v-media-vr v-if="isShowMediaVr" :show.sync="isShowMediaVr" :multiple="multiple" :ids="selectedVrIds" @select="handleSelectVr" />
  </el-dialog>
</template>

<script>
import vrUpload from './vr-upload';
export default {
  props: ['show', 'row'],

  components: { vrUpload },

  data() {
    return {
      loading: false,
      groupListLoading: false,
      scentListLoading: false,
      doSubmitLoading: false,
      groupList: [],
      scentList: [],
      vrIndex: '',
      isShowMediaVr: false,
      vForm: {
        works_id: this.row.id,
        group_name: '',
        keys: [], //资源id
        record_time: '',
        status: 1,
      },
      materialVrs: [],
      multiple: false,
      selectedVrIds: [],
    };
  },

  created() {
    this.getCategory();
  },

  computed: {
    materialVrsFilter: function () {
      return this.materialVrs.filter((item, index) => index + 1 > this.scentList.length);
    },
  },

  methods: {
    //分组列表
    async getCategory() {
      this.groupListLoading = true;
      try {
        let res = await this.api.group.lists({ works_id: this.row.id });
        this.groupList = res.data;
        this.getSceneList(this.groupList[0].id);
      } catch (e) {
        console.error(e);
      }
      this.groupListLoading = false;
    },

    //获取场景列表
    async getSceneList(group_id) {
      this.scentListLoading = true;
      try {
        let res = await this.api.works.getSceneList({
          works_id: this.row.id,
          group_id,
        });
        this.scentList = res.data;
        this.materialVrs.length = this.scentList.length;
      } catch (e) {
        console.error(e);
      }
      this.scentListLoading = false;
    },

    //获取所有场景列表
    async getSceneListAll() {
      let res = await this.api.works.getSceneList({
        works_id: this.row.id,
      });
      return res.data;
    },

    closeDialog() {
      this.$emit('update:show', false);
    },

    openWindow(url) {
      window.open(url, '_blank');
    },

    //提交作品
    async doSubmit() {
      await this.$refs.vForm.validate();
      this.doSubmitLoading = true;
      try {
        await this.api.works.retakeWorks(this.vForm);
        this.$message.success('更新成功');
        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped>
.group-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 5px;
  min-height: 30px;
  min-width: 100px;
}

.group-item {
  height: 25px;
  padding: 0 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-left: 5px;
  margin-bottom: 5px;
}

.group-item.active {
  margin-left: 0;
  color: #409eff;
  border-color: #409eff;
}

.scene-list {
  min-height: 100px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.scene-upload {
  position: relative;
  width: 200px;
  height: 100px;
  line-height: 1.5;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scene-upload.batch {
  border-color: #67c23a;
  color: #67c23a;
}

.scene-upload.new {
  border-color: #e6a23c;
  color: #e6a23c;
}

.scene-upload .icon {
  font-size: 22px;
  margin-bottom: 5px;
}

.scene-preview {
  width: 200px;
  height: 100px;
  margin: 0 10px 10px 0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.scene-preview-img {
  display: block;
  width: 100%;
  height: 100%;
}

.scene-preview-footer {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px 10px;
  height: 30px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
}

.scene-preview-footer .name {
  flex: 1;
}

.scene-preview-footer .operate-btn {
  margin-left: 10px;
  cursor: pointer;
}
</style>
